import './tabs-controller';



// WEBPACK FOOTER //
// ./project/client/src/core/components/tabs/index.js